import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 工單出庫候選（Draft：`mom.work_order.stock_issue.candidates`）。
 * GET `/mom/work-order/{id}/stock-issue-candidates` → detail；僅 **PROCESSING**。
 *
 * `data.warehouse`＋`list[]`：
 * - `mtr`、`requiredQty`、`completedIssueQty`、`remainingQty`
 * - `sources[]`：`sourceType`、`id`、`stockNo`、`availableQty`
 *
 * `remainingQty=0` **仍回** sources（可超領 → 後端算 `loss_qty`）。
 *
 * @param {string} id 工單 id
 */
export async function fetchWorkOrderStockIssueCandidates(id) {
  const { data: raw } = await request.get(
    `/mom/work-order/${id}/stock-issue-candidates`,
  );
  return parseVer4DetailResponse(raw);
}
